import { FailureCodeEnum as InvoiceDisputedFailureCode } from 'anchor-ts-infra/src/dto/invoice';
// eslint-disable-line @typescript-eslint/no-explicit-any
export let BillingTriggerType;

(function (BillingTriggerType) {
  BillingTriggerType["OnApproval"] = "approval";
  BillingTriggerType["Ongoing"] = "ongoing";
  BillingTriggerType["OneTimeManual"] = "oneTimeManual";
  BillingTriggerType["RepeatableManual"] = "repeatableManual";
  BillingTriggerType["OneTimeDelivery"] = "oneTimeDelivery";
})(BillingTriggerType || (BillingTriggerType = {}));

export let PlaidAccountType;

(function (PlaidAccountType) {
  PlaidAccountType["Depository"] = "depository";
  PlaidAccountType["Credit"] = "credit";
  PlaidAccountType["Loan"] = "loan";
  PlaidAccountType["Investment"] = "investment";
  PlaidAccountType["Other"] = "other";
})(PlaidAccountType || (PlaidAccountType = {}));

export let PlaidDepositoryAccountSubtype;

(function (PlaidDepositoryAccountSubtype) {
  PlaidDepositoryAccountSubtype["Checking"] = "checking";
  PlaidDepositoryAccountSubtype["Savings"] = "savings";
  PlaidDepositoryAccountSubtype["HSA"] = "hsa";
  PlaidDepositoryAccountSubtype["CD"] = "cd";
  PlaidDepositoryAccountSubtype["MoneyMarket"] = "money market";
  PlaidDepositoryAccountSubtype["Paypal"] = "paypal";
  PlaidDepositoryAccountSubtype["Prepaid"] = "prepaid";
  PlaidDepositoryAccountSubtype["CashManagement"] = "cash management";
  PlaidDepositoryAccountSubtype["EBT"] = "ebt";
})(PlaidDepositoryAccountSubtype || (PlaidDepositoryAccountSubtype = {}));

export let VobQboState;

(function (VobQboState) {
  VobQboState["Started"] = "started";
  VobQboState["ConnectionTriggered"] = "connectionTriggered";
  VobQboState["Canceled"] = "canceled";
  VobQboState["Done"] = "done";
})(VobQboState || (VobQboState = {}));

export let StartBillingOnEnum;

(function (StartBillingOnEnum) {
  StartBillingOnEnum["SkipBillingOnAcceptance"] = "skipBillingOnAcceptance";
  StartBillingOnEnum["Earliest"] = "earliest";
  StartBillingOnEnum["StartPaused"] = "startPaused";
})(StartBillingOnEnum || (StartBillingOnEnum = {}));

export let InvoicePaymentMethodStatus;

(function (InvoicePaymentMethodStatus) {
  InvoicePaymentMethodStatus["PaymentMethodSet"] = "paymentMethodSet";
  InvoicePaymentMethodStatus["PaymentMethodNotSet"] = "paymentMethodNotSet";
  InvoicePaymentMethodStatus["PaymentMethodUnverified"] = "paymentMethodUnverified";
})(InvoicePaymentMethodStatus || (InvoicePaymentMethodStatus = {}));

export let InvoiceStatus;

(function (InvoiceStatus) {
  InvoiceStatus["RequiresPaymentApproval"] = "requiresPaymentApproval";
  InvoiceStatus["PaymentActionRequired"] = "paymentActionRequired";
  InvoiceStatus["PaymentFailed"] = "paymentFailed";
  InvoiceStatus["PaymentStopped"] = "paymentStopped";
  InvoiceStatus["Pending"] = "pending";
  InvoiceStatus["ProcessingCharge"] = "processingCharge";
  InvoiceStatus["PaymentConfirmed"] = "paymentConfirmed";
  InvoiceStatus["Paid"] = "paid";
  InvoiceStatus["PaidExternally"] = "paidExternally";
  InvoiceStatus["Voided"] = "voided";
  InvoiceStatus["Refunded"] = "refunded";
  InvoiceStatus["RefundFailed"] = "refundFailed";
  InvoiceStatus["PaymentDisputed"] = "paymentDisputed";
})(InvoiceStatus || (InvoiceStatus = {}));

export let LineItemPendingApprovalReason;

(function (LineItemPendingApprovalReason) {
  LineItemPendingApprovalReason["AdHocCharge"] = "ad-hoc-charge";
  LineItemPendingApprovalReason["ServiceAmendment"] = "service-amendment";
  LineItemPendingApprovalReason["VariableExceedsCap"] = "variable-exceeds-cap";
  LineItemPendingApprovalReason["VariableZeroCap"] = "variable-zero-cap";
  LineItemPendingApprovalReason["RangeExceedsMaxPrice"] = "range-exceeds-max-price";
  LineItemPendingApprovalReason["VariableCumulative"] = "variable-cumulative";
  LineItemPendingApprovalReason["NonVariableCumulative"] = "non-variable-cumulative";
  LineItemPendingApprovalReason["OverlappingPeriod"] = "overlapping-period";
})(LineItemPendingApprovalReason || (LineItemPendingApprovalReason = {}));

export { InvoiceDisputedFailureCode };